import { sem_imagem as semImg } from '@/constants';

// Monta src a partir de Blob ou base64, com fallback
export const buildImageSrc = (img?: Blob | string, mimeFallback = 'image/webp') => {
  if (!img) return `data:image/jpeg;base64,${semImg}`;
  if (img instanceof Blob) return URL.createObjectURL(img);
  if (img.startsWith('data:')) return img;
  return `data:${mimeFallback};base64,${img}`;
};

export const buildImageSrcError = (e: React.SyntheticEvent<HTMLImageElement>) => {
  try {
    (e.target as HTMLImageElement).src = `data:image/jpeg;base64,${semImg}`;
  } catch (error) {
    console.error(error);
  }
};